export default "__VITE_ASSET__DID3O7DO__"